export enum NotificationsTypes {
  /** Email notifications */
  EMAIL = "EMAIL",
  /** mobile app notifications */
  IN_APP = "IN_APP",
}
